import { CONSORS_PROFESSIONS } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsProfession = z.nativeEnum(CONSORS_PROFESSIONS);

export type SchemaConsorsProfession = z.infer<typeof schemaConsorsProfession>;
